import {h} from 'preact';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import {mapRootUrl} from '@util/URLUtils';
import {dropMenuNav} from '../../styles';
import DropMenu from '../';
import Menu from '../../Menu';

const Nav = ( {menuItems = []} ) =>
    <nav className={dropMenuNav.root}>
        <ul className={dropMenuNav.list}>
            {menuItems
                .map( item =>
                    <DropMenu.navItem {...item}>
                        {!isEmptyOrNil( item.children ) &&
                        <Menu menuItems={item.children.map( mapRootUrl( item ) )}/>
                        }
                    </DropMenu.navItem>
                )}
        </ul>
    </nav>;

export default Nav;